import { TableRow } from "@material-ui/core";
import { memo } from "react";
import { useRankingClienteService } from "../../context/RankingClienteContext";
import AccountTableCell from "./AccountTableCell";
import GroupHeaderTableRow from "./GroupHeaderTableRow";
import GroupTotalRow from "./GroupTotalRow";

const RecursiveGroupedTableRow = ({ cell, level }) => {
  const { columns, isGrouped } = useRankingClienteService();

  const children = cell?.children?.map((child, childIndex) => (
    <RecursiveGroupedTableRow cell={child} level={level + 1} key={childIndex} />
  ));

  const rows =
    cell.customers?.map((customer) => ({
      ...customer,
      company: `${customer.company.id} - ${customer.company.description}`,
    })) ?? [];

  return (
    <>
      {isGrouped && (
        <GroupHeaderTableRow cell={cell} columns={columns} level={level} />
      )}
      {rows.map((groupedCell, groupIndex) => (
        <TableRow key={`${groupedCell.id}-${groupIndex}`}>
          {columns?.map((column) => (
            <AccountTableCell
              key={column.id}
              align={column.align}
              id={column.id}
              style={column.style}
              width={column.width}
              data={
                column.format
                  ? column.format(groupedCell[column.id])
                  : groupedCell[column.id]
              }
            />
          ))}
        </TableRow>
      ))}
      {children}
      {
        <GroupTotalRow
          total={cell.total}
          columns={columns}
          count={rows.length ?? 0}
        />
      }
    </>
  );
};

export default memo(RecursiveGroupedTableRow);
